import { ArrowsPointingOutIcon } from '@heroicons/react/16/solid';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useModalsContext } from '../../../../../../providers/ModalsProvider/Modals.context.ts';
import { useSyncConversationsContext } from '../../../../../../providers/SyncConversationsProvider/SyncConversations.context.tsx';
import { SyncConversationsEnum } from '../../../../../../providers/SyncConversationsProvider/SyncConversations.enum.ts';
import './SyncConversationsToaster.styles.scss';

export default function SyncConversationsToaster() {
  const { setSyncConversationsStatus } = useModalsContext();
  const { t } = useTranslation('dashboard/dashboard');
  const { syncConversations, totalConversations, initialProgress } =
    useSyncConversationsContext();

  const calculatePercentage = () => {
    return (syncConversations / totalConversations) * 100;
  };

  useEffect(() => {
    if (syncConversations >= totalConversations) {
      setSyncConversationsStatus(SyncConversationsEnum.SUCCESS);
    }
  }, [syncConversations]);

  return (
    <div className="SyncConversationsToaster">
      <div className="SyncConversationsToaster__Container">
        <div className="SyncConversationsToaster__Container__Header">
          {initialProgress >= 100 ? (
            <h1 className="SyncConversationsToaster__Container__Header_Title">
              {t('components.modals.SyncConversations.toaster.titleDone', {
                syncConversations,
                totalConversations,
              })}
            </h1>
          ) : (
            <strong>
              {t('components.modals.SyncConversations.toaster.titleSyncing')}
            </strong>
          )}
          <ArrowsPointingOutIcon
            onClick={() =>
              setSyncConversationsStatus
                ? setSyncConversationsStatus(SyncConversationsEnum.SYNCING)
                : undefined
            }
            className="SyncConversationsToaster__Container__Header__Icon"
          />
        </div>
      </div>
      {initialProgress < 100 && (
        <div className="SyncConversationsToaster__Container__Progress">
          {initialProgress} %
        </div>
      )}

      <div className="SyncConversationsToaster__Container__Bottom">
        <div
          className="SyncConversationsToaster__Container__Bottom__ProgresBar"
          style={{
            width: `${initialProgress >= 100 ? calculatePercentage() : initialProgress}%`,
          }}
        ></div>
      </div>
    </div>
  );
}
